
export const SUPPORTING_DATA_REQUESTED = 'infobar/SUPPORTING_DATA_REQUESTED';
export const SUPPORTING_DATA_SUCCESS = 'infobar/SUPPORTING_DATA_SUCCESS';
export const SUPPORTING_DATA_FAILURE = 'infobar/SUPPORTING_DATA_FAILURE';

export const FETCH_SNIPPETS_REQUESTED = 'infobar/FETCH_SNIPPETS_REQUESTED';
export const FETCH_SNIPPETS_SUCCESS = 'infobar/FETCH_SNIPPETS_SUCCESS';
export const FETCH_SNIPPETS_FAILURE = 'infobar/FETCH_SNIPPETS_FAILURE';
